module.exports = __webpack_public_path__ + "static/woman-ov-0c06f7ca5d33c985da10c4b8117e8526.jpg";